// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TabNav_tabNavContainer__DK\\+dG {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--color-border);
  background: var(--color-surface-light);
}

.TabNav_tabNav__lh9EI {
  display: flex;
  border-bottom: 1px solid var(--color-border);
  background: var(--color-surface-light);
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
  scrollbar-width: none; /* Hide scrollbar in Firefox */
  /* Hide scrollbar in webkit browsers while preserving functionality */
}
.TabNav_tabNav__lh9EI::-webkit-scrollbar {
  display: none;
}

.TabNav_tabButton__b65lz {
  background: none;
  border: none;
  color: var(--color-text-subtle);
  font-weight: 500;
  cursor: pointer;
  padding: 0.75rem var(--gutter);
  transition: background var(--animation-duration-default), color var(--animation-duration-default);
  outline: none;
  flex-shrink: 0; /* Prevent buttons from shrinking */
}
.TabNav_tabButton__b65lz:hover:not(.TabNav_active__XwqzT) {
  background: var(--color-surface-darker);
  color: var(--color-text);
}
.TabNav_tabButton__b65lz.TabNav_active__XwqzT {
  background: var(--color-primary);
  color: var(--color-text-light);
  z-index: 2;
}

.TabNav_tabActions__wTLRq {
  display: flex;
  align-items: center;
  padding: 0 var(--gutter);
  gap: var(--gutter);
}`, "",{"version":3,"sources":["webpack://./src/components/TabNav/TabNav.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,4CAAA;EACA,sCAAA;AACF;;AAEA;EACE,aAAA;EACA,4CAAA;EACA,sCAAA;EACA,gBAAA;EACA,mBAAA;EACA,iCAAA,EAAA,4BAAA;EACA,qBAAA,EAAA,8BAAA;EAEA,qEAAA;AAAF;AACE;EACE,aAAA;AACJ;;AAGA;EACE,gBAAA;EACA,YAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,8BAAA;EACA,iGAAA;EACA,aAAA;EACA,cAAA,EAAA,mCAAA;AAAF;AAEE;EACE,uCAAA;EACA,wBAAA;AAAJ;AAGE;EACE,gCAAA;EACA,8BAAA;EACA,UAAA;AADJ;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,kBAAA;AAFF","sourcesContent":[".tabNavContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid var(--color-border);\n  background: var(--color-surface-light);\n}\n\n.tabNav {\n  display: flex;\n  border-bottom: 1px solid var(--color-border);\n  background: var(--color-surface-light);\n  overflow-x: auto;\n  white-space: nowrap;\n  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */\n  scrollbar-width: none; /* Hide scrollbar in Firefox */\n  \n  /* Hide scrollbar in webkit browsers while preserving functionality */\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.tabButton {\n  background: none;\n  border: none;\n  color: var(--color-text-subtle);\n  font-weight: 500;\n  cursor: pointer;\n  padding: 0.75rem var(--gutter);\n  transition: background var(--animation-duration-default), color var(--animation-duration-default);\n  outline: none;\n  flex-shrink: 0; /* Prevent buttons from shrinking */\n\n  &:hover:not(.active) {\n    background: var(--color-surface-darker);\n    color: var(--color-text);\n  }\n\n  &.active {\n    background: var(--color-primary);\n    color: var(--color-text-light);\n    z-index: 2;\n  }\n} \n\n.tabActions {\n  display: flex;\n  align-items: center;\n  padding: 0 var(--gutter);\n  gap: var(--gutter);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabNavContainer": `TabNav_tabNavContainer__DK+dG`,
	"tabNav": `TabNav_tabNav__lh9EI`,
	"tabButton": `TabNav_tabButton__b65lz`,
	"active": `TabNav_active__XwqzT`,
	"tabActions": `TabNav_tabActions__wTLRq`
};
export default ___CSS_LOADER_EXPORT___;
